export default __webpack_public_path__ + "static/media/microcapNFO.dddc505f.gif";